// The review screen's half of the draft gate's exposure record (stage 3,
// #331; spec §2 "What the reviewer saw"; server lib/gateViews.js).
//
// A review session is one screen: a random id made when the page mounts, so
// two tabs are two sessions. When the screen COMMITS a gated draft to the
// visible form it activates a gate view with POST /documents/:id/gate-view
// { review_session_id, form_rev } — form_rev from the opening it committed
// (utils/openingForm.js formRev), never from live state. The decision then
// sends the view back in its `review` payload. The answer is also the mark
// the review strip shows (PR C, utils/gateMark.js): its colour, 'hidden' for
// a held-out green, 'pending' while the server has no holdout salt.

// MUST STAY IN SYNC with server/lib/draftGate.js GATED_DOC_TYPES.
export const GATED_DOC_TYPES = Object.freeze(['חשבונית', 'תעודת משלוח']);
// After this many stale answers in a row the screen keeps its copy and stops
// asking; the draft then has no view (spec §2).
export const MAX_STALE_ATTEMPTS = 3;

export const isGatedDraft = (d) => !!d && d.status === 'טיוטה' && GATED_DOC_TYPES.includes(d.doc_type);

/** A session id the server accepts (/^[A-Za-z0-9-]{8,64}$/). */
export function newReviewSessionId(rand = typeof window !== 'undefined' ? window.crypto : undefined) {
  if (rand?.randomUUID) return rand.randomUUID();
  const hex = Array.from({ length: 32 }, () => Math.floor(Math.random() * 16).toString(16)).join('');
  return `rs-${hex}`;
}

/**
 * The fields a decision adds to its `review`: the view only when it is this
 * document's, with the formRev of the copy the decision was made from.
 */
export function gateReviewFields(view, documentId, sessionId) {
  if (!view || view.viewId == null || String(view.docId) !== String(documentId)) return {};
  return { gate_view_id: view.viewId, review_session_id: sessionId, ...(view.formRev ? { gate_form_rev: view.formRev } : {}) };
}
